//  [REDUCER][TYPE]
import { typeCreatorV2 } from '../../utils/common';

export const SET_INTEREST: string = typeCreatorV2(
  'CommonReducer',
  'SetInterest'
);

export const SET_GLOBAL_SEARCH: string = typeCreatorV2(
  'CommonReducer',
  'SetGlobalSearch'
);
export const SET_CUSTOMER_NOTIFICATIONS_LIST: string = typeCreatorV2(
  'CommonReducer',
  'SetCustomer_NotificationsList'
);
export const SET_EDIT_CUSTOMER_NOTIFICATIONS: string = typeCreatorV2(
  'CommonReducer',
  'SetEditCustomer_Notifications'
);
